<template>
  <div id="pageRoot">
    <span id="bg" class="backgroundTopRect"></span>

    <span id="clouds" class="pageElement slideItem"></span>

    <span id="clothes" class="popUpAnimation"></span>

    <span id="rain" class="appearAnimationB"></span>

    <span id="title" class="appearAnimationB"></span>
  </div>
</template>
<style scoped>
#title {
  position: absolute;
  width: 638px;
  height: 87px;
  left: 302px;
  top: 53px;
  z-index: 3;
  background-image: url(/pages/img/sordoglo/svgGlo1Title.svg);
  animation-delay: 0.7s;
}

#bg {
  position: absolute;
  width: 926px;
  height: 597.22px;
  left: 65px;
  top: 115px;
  z-index: 0;
  background-image: url(/pages/img/sordoglo/svgGlo1bg.svg);
}

#clouds {
  position: absolute;
  width: 816.22px;
  height: 379px;
  left: 16.78px;
  top: 0px;
  z-index: 1;
  background-image: url(/pages/img/sordoglo/svgGlo1Clouds.svg);
}

#clothes {
  position: absolute;
  width: 964px;
  height: 252.91px;
  left: 9px;
  top: 253px;
  z-index: 2;
  background-image: url(/pages/img/sordoglo/svgGlo1Clothes.svg);
  animation-delay: 0.3s;
}

#rain {
  position: absolute;
  width: 944.03px;
  height: 864.68px;
  left: 67px;
  top: -220px;
  z-index: 2;
  background-image: url(/pages/img/sordoglo/svgGlo1Rain.svg);
  animation-delay: 0.1s;
}

.backgroundTopRect {
  animation-name: backgroundTopRect-animation;
  animation-duration: 0.5s;
  animation-timing-function: cubic-bezier(0.07, 0.42, 0.61, 0.99);
}

@keyframes backgroundTopRect-animation {
  from {
    transform: translateY(-120px);
  }
  to {
    transform: translateY(0px);
  }
}

.popUpAnimation {
  opacity: 0;
  transform: translateY(120px) scale(0);
  animation-name: popUp-animation;
  animation-duration: 0.3s;
  animation-timing-function: cubic-bezier(0.07, 0.42, 0.48, 1.45);
  animation-fill-mode: forwards;
}
@keyframes popUp-animation {
  from {
    opacity: 0;
    transform: translateY(120px) scale(0);
  }
  to {
    opacity: 1;
    transform: translateY(0px) scale(1);
  }
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["glo/Video 1b.mp4"]
    }
  }
}
</script>